import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button, InputBase } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';
import URI from 'urijs';
import posthog from 'posthog-js';

import './scss/index.scss';
import './scss/login.scss';
import Color from '@tool/color';
import LoginSlick from './component/login-slick';
import LoginComp from './component/login-comp';
import TwoLogin from './login';
import AppLogin from '@con/app-login';
import AppLoading from '@con/app-loading';
import { isOAuthAuthorizationNavigation } from '@lib/oauth-authorization';

interface IProps {}
interface IState {}

const DButton = styled(Button)(() => ({}));

const LoginButton = styled(Button)(() => ({}));

const DInput = styled(InputBase)(() => ({}));

const Login = (props: IProps, state: IState) => {
  const navi = useNavigate();

  useEffect(() => {
    document.title = '登录';
    if (!isOAuthAuthorizationNavigation(window.location.search)) {
      posthog.capture('访问登录页人数', {});
    }

    return () => {};
  }, []);

  return (
    <section className="page-1101">
      <LoginSlick />
      <LoginComp>
        <TwoLogin />
      </LoginComp>
      <AppLogin />
      <AppLoading />
    </section>
  );
};

export default observer(Login);
